import axios from "axios";
import { brand } from "@/lib/brand";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "iemed_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const isLogin = err.config?.url?.includes("/auth/login");
    if (err.response?.status === 401 && !isLogin) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname.startsWith("/crm")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errorMessage(err, fallback = "Ocurrió un error. Inténtalo de nuevo.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return brand(detail);
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg || "").replace(/^Value error, /, "")).join(" ");
  return fallback;
}
